module.exports = __webpack_public_path__ + "img/apple.36e29bfe.svg";